module.exports = __webpack_public_path__ + "static/img/irole.f7b1f4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/bz/irole.png
// module id = NkS/
// module chunks = 7